import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Typography,
  Chip,
  Box,
  Collapse
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon
} from '@mui/icons-material';
import DetallePedidoExpandido from './DetallePedidoExpandido';

const TablaPedidos = ({ pedidos, expandedPedido, onExpandPedido }) => {
  
  const formatFecha = (fechaString) => {
    if (!fechaString) return 'N/A';
    const date = new Date(fechaString);
    return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
  };

  // Función para truncar texto largo
  const truncarTexto = (texto, maxLength) => {
    if (!texto) return 'N/A';
    if (texto.length <= maxLength) return texto;
    return texto.substring(0, maxLength) + '...';
  };

  return (
    <>

      <TableContainer component={Paper} sx={{ maxHeight: '60vh', marginBottom:'10px' }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ py: 1, fontWeight: 'bold', width: 130 }}>Remito</TableCell>
              <TableCell sx={{ py: 1, fontWeight: 'bold', width: 90 }}>Fecha</TableCell>
              <TableCell sx={{ py: 1, fontWeight: 'bold', minWidth: 150 }}>Dirección</TableCell>
              <TableCell sx={{ py: 1, fontWeight: 'bold', minWidth: 150 }}>Producto</TableCell>
              <TableCell sx={{ py: 1, fontWeight: 'bold', width: 120 }}>Chofer</TableCell>
              {/* <TableCell sx={{ py: 1, fontWeight: 'bold', width: 100 }}>Estado</TableCell> */}
              <TableCell sx={{ py: 1, fontWeight: 'bold', width: 60 }}>Detalle</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {pedidos.map((pedido) => (
              <React.Fragment key={pedido.id}>
                <TableRow hover sx={{ '& > td': { py: 0.5 } }}>
                  {/* Columna ID */}
                  <TableCell>
                    <Typography variant="body2" fontWeight="bold">
                      {pedido.remito_entrega}
                    </Typography>
                  </TableCell>
                  
                  {/* Columna Fecha */}
                  <TableCell>
                    <Typography variant="body2">
                      {formatFecha(pedido.fecha_orden)}
                    </Typography>
                    {/* {pedido.fecha_format && (
                      <Typography variant="caption" color="textSecondary" display="block">
                        {pedido.fecha_format}
                      </Typography>
                    )} */}
                  </TableCell>
                  
                  {/* Columna Dirección */}
                  <TableCell>
                    <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>
                      {truncarTexto(pedido.direccion_entrega, 40)}
                    </Typography>
                    {pedido.sucursal_cliente && (
                      <Typography variant="caption" color="textSecondary" display="block">
                        {pedido.sucursal_cliente}
                      </Typography>
                    )}
                  </TableCell>
                  
                  {/* Columna Producto */}
                  <TableCell>
                    <Typography variant="body2">
                      {pedido.producto}
                    </Typography>
                    {/* {pedido.tipo && (
                      <Typography variant="caption" color="textSecondary" display="block">
                        Tipo: {pedido.tipo === 1 ? 'Normal' : 'Especial'}
                      </Typography>
                    )} */}
                  </TableCell>
                  
                  {/* Columna Chofer */}
                  <TableCell>
                    <Typography variant="body2">
                      {pedido.nombre_apellido || 'No asignado'}
                    </Typography>
                    {/* {pedido.id_chofer && (
                      <Typography variant="caption" color="textSecondary" display="block">
                        ID: {pedido.id_chofer}
                      </Typography>
                    )} */}
                  </TableCell>
                  
                  {/* Columna Estado */}
                  {/* <TableCell>
                    <Chip 
                      label={pedido.valor}
                      size="small"
                      color={
                        pedido.valor === 'Entregado Con Remito' ? 'success' : 
                        pedido.estado === 354 ? 'primary' : 'default'
                      }
                      sx={{ height: 20, fontSize: '0.7rem' }}
                    />
                    {pedido.cambio !== 'NO' && (
                      <Typography variant="caption" color="warning.main" display="block" sx={{ mt: 0.5 }}>
                        {pedido.cambio}
                      </Typography>
                    )}
                  </TableCell> */}
                  
                  {/* Columna Detalle (para expandir) */}
                  <TableCell>
                    <IconButton 
                      size="small" 
                      onClick={() => onExpandPedido(pedido.id)}
                      sx={{ p: 0.5 }}
                    >
                      {expandedPedido === pedido.id ? 
                        <ExpandLessIcon fontSize="small" /> : 
                        <ExpandMoreIcon fontSize="small" />
                      }
                    </IconButton>
                  </TableCell>
                </TableRow>
                
                {/* Detalle expandido */}
                <TableRow>
                  <TableCell colSpan={7} style={{ padding: 0 }}>
                    <Collapse in={expandedPedido === pedido.id} timeout="auto" unmountOnExit>
                      <DetallePedidoExpandido pedido={pedido} />
                    </Collapse>
                  </TableCell>
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default TablaPedidos;